import { useMainstreamCountries } from '@/hooks/queries/use-mainstream-countries';
import type { InstitutionDetailsPartial, InstitutionDetailsV2Partial } from '@/services/api/profile';
import { isJurisdictionPermitted } from '@/utils';

// The forbidden-jurisdiction page an ineligible firm is held on, under the onboarding path its answers belong to
export const useInstitutionOnboardingIneligiblePath = (onboardingPath: string, answers: InstitutionDetailsPartial | InstitutionDetailsV2Partial | null | undefined) => {
  const { data: countries } = useMainstreamCountries();
  const countryOfIncorporation = answers?.incorporation?.countryOfIncorporation;
  const countryOfBranchOperations = answers?.branchOperations?.countryOfBranchOperations;

  if (!countries) return undefined;

  if (countryOfIncorporation && !isJurisdictionPermitted(countryOfIncorporation, countries)) {
    return `${onboardingPath}/incorporation/forbidden-jurisdiction/${countryOfIncorporation}`;
  }

  if (countryOfBranchOperations && !isJurisdictionPermitted(countryOfBranchOperations, countries)) {
    return `${onboardingPath}/branch-operations/forbidden-jurisdiction/${countryOfBranchOperations}`;
  }

  return undefined;
};
